import React, { useEffect, useContext, useState } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import CreateAssetPage from './AssetForms/CreateAsset';
import UpdateNotesPage from './AssetForms/UpdateNotes';
import AssetDocumentPage from './AssetForms/AssetDocument';
import AssetHistoryPage from './AssetForms/AssetHistory';
import AssetWarrantyPage from './AssetForms/AssetWarranty';
import Draggable from 'react-draggable';
import JobsListPage from "../../Jobs/View/JobsList";
import AssetService from "../Controller/AssetController";
import AssetReportsPage from "./AssetForms/AssetReports";
import AssetUserDefineFields from "./AssetForms/AssetUserDefineFields";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import HelpSite from "../../Common/HelpLink";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
    Invoices: 22,
};
function CustomerDetail({ AssetID, onClose, onSuccess, ClientCompanyID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AdministrationSetting";
    //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [isMinimized, setIsMinimized] = useState(false);
    const [assetName, setAssetName] = useState("Asset Details");
    const [activeTab, setActiveTab] = useState('tab-Asset');
    const [writeOff, setwriteOff] = useState("0");


    const [currentAssetID, setCurrentAssetID] = useState(AssetID);
    const [assignedModules, setAssignedModules] = useState(new Set());
    const [isLock, setIsLock] = useState(0);
    const UserID = localStorage.getItem("UserID");
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    useEffect(() => {
        setCurrentAssetID(AssetID);
        setActiveTab('tab-Asset');
        if (AssetID > 0) {
            fetchAssetDetail(AssetID);
            fetchAssignedModules();
        } else {
            setAssetName("Asset Details");
        }

    }, [AssetID]);
    const fetchAssetDetail = async (newAssetID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (newAssetID > 0) {
                const AssetDetail = await AssetService.GetAssetByID(redirectCallback, newAssetID);
                setAssetName(AssetDetail[0].vc_AssetName); // Update this line to match your data structure

                if (AssetDetail[0].isLock === 1 && AssetDetail[0].LockBy != UserID) {
                    setIsLock(1);
                }
                else {
                    setIsLock(0);
                    await AssetService.LockAsset(newAssetID);
                }
               
                if (AssetDetail[0].isWriteOff?.toString() === "1") {
                    setwriteOff("1");
                }
            }
        } catch (error) {
            console.error('Error fetching asset details:', error);
        }
    };
    const handleSuccess = async () => {
        const newAssetID = parseInt(localStorage.getItem('AssetID'), 10);
        setCurrentAssetID(newAssetID);
        await fetchAssetDetail(newAssetID);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    let tabClass = (currentAssetID > 0) ? "nav-link" : "nav-link disabled";

    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };
    return (


        <div className="modal fade assetDetailModal show d-block" id="assetDetailModal" tabIndex="-1" aria-labelledby="assetDetailModalLabel" aria-hidden="false" data-backdrop="static">
            <div className={`modal-dialog ${ClientCompanyID > 0 ? 'modal-lg' : 'modal-xl'}`}>
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{assetName} <strong style={{ fontSize: "14px", color: "red" }}> {isLock.toString() === "0" ? "" : "(Locked)"}</strong></h5>
                            <span>

                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="false">&times;</span>
                                </button>
                                <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize">
                                    <span aria-hidden="false">{isMinimized ? '+' : '-'}</span>
                                </button>

                            </span>
                        </div>
                        {!isMinimized && (
                            <div className="modal-body" style={{ flex: "1" }}>
                                <div className="row vertical-pills-tab">
                                    <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "20px", marginRight: "25px", width: "100%", background: "#fff", borderBottom: "1px solid #d8e0e3" }}>
                                        <ul className="nav nav-tabs" style={{ border: "none", borderColor: "none" }}>
                                            <li className="nav-item">
                                                <a style={{ padding: "0.2rem" }} className={`nav-link ${activeTab === 'tab-Asset' ? 'active' : ''}`} onClick={() => setActiveTab('tab-Asset')} data-toggle="pill" href="#tab-Asset">
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/asset_details.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Details</strong>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Assetsites' ? 'active' : ''}`} onClick={() => setActiveTab('tab-Assetsites')} data-toggle="pill" href="#tab-Assetsites">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/asset_warranty-details.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Warranty Details".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/asset_warranty-details.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Warranty Details".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Assetcontacts' ? 'active' : ''}`} onClick={() => setActiveTab('tab-Assetcontacts')} data-toggle="pill" href="#tab-Assetcontacts"> <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/asset_detailed-description.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                            {"Detailed Descrip...".split(" ").map((word, i) => (
                                                                <span key={i} className="top-word">
                                                                    {word}
                                                                </span>
                                                            ))}
                                                        </strong>
                                                    </div></a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/asset_detailed-description.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Detailed Descrip...".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                            <li className="nav-item">
                                                {assignedModules.has(MODULE_IDS.Jobs) && isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Assetdiscounting' ? 'active' : ''}`} onClick={() => setActiveTab('tab-Assetdiscounting')} data-toggle="pill" href="#tab-Assetdiscounting"> <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/asset_jobs.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Jobs</strong>
                                                    </div></a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/asset_jobs.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Jobs</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            {/* {isLock.toString() === "0" ? (
                                                <a className={`${tabClass} ${activeTab === 'tab-userDefineFields' ? 'active' : ''}`} onClick={() => setActiveTab('tab-userDefineFields')} data-toggle="pill" href="#tab-userDefineFields">User Define Fields</a>
                                            ) : (
                                                <a className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                    User Define Fields
                                                </a>
                                            )}*/}
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Assetcosts' ? 'active' : ''}`} onClick={() => setActiveTab('tab-Assetcosts')} data-toggle="pill" href="#tab-Assetcosts">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/asset_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Documents</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/asset_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Documents</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Assetjobs' ? 'active' : ''}`} onClick={() => setActiveTab('tab-Assetjobs')} data-toggle="pill" href="#tab-Assetjobs">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/asset_history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>History</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/asset_history.png.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>History</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                        </ul>
                                        <div className="ml-auto">
                                            {activeTab === "tab-Asset" && (
                                                <HelpSite FormName="Asset" Module="4" />
                                            )}
                                            {activeTab === "tab-Assetsites" && (
                                                <HelpSite FormName="Warranty Details" Module="4" />
                                            )}
                                            {activeTab === "tab-Assetcontacts" && (
                                                <HelpSite FormName="Detailed Description" Module="4" />
                                            )}
                                            {activeTab === "tab-Assetdiscounting" && (
                                                <HelpSite FormName="Asset Job" Module="4" />
                                            )}
                                            {activeTab === "tab-userDefineFields" && (
                                                <HelpSite FormName="User Define Fields" Module="4" />
                                            )}
                                            {activeTab === "tab-Assetcosts" && (
                                                <HelpSite FormName="Document" Module="4" />
                                            )}
                                            {activeTab === "tab-Assetjobs" && (
                                                <HelpSite FormName="History" Module="4" />
                                            )}
                                            {activeTab === "tab-Assetquotation" && (
                                                <HelpSite FormName="Report" Module="3" />
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-12 pl-0">
                                        <div className="tab-content p-3" id="v-pills-tabContent">
                                            <div className={`tab-pane fade ${activeTab === 'tab-Asset' ? 'show active' : ''}`} id="tab-Asset" role="tabpanel">
                                                <CreateAssetPage AssetID={parseInt(currentAssetID, 10)} onSuccess={handleSuccess} ClientCompanyID={ClientCompanyID} isLock={isLock} onClose={onClose} writeOff={writeOff} />
                                            </div>
                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Assetsites' ? 'show active' : ''}`} id="tab-Assetsites" role="tabpanel">
                                                    <AssetWarrantyPage AssetID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Assetcontacts' ? 'show active' : ''}`} id="tab-Assetcontacts" role="tabpanel">
                                                    <UpdateNotesPage AssetID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentAssetID > 0 && assignedModules.has(MODULE_IDS.Jobs) && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Assetdiscounting' ? 'show active' : ''}`} id="tab-Assetdiscounting" role="tabpanel">
                                                    <JobsListPage CustomerID={parseInt("0")} AssetID={parseInt(currentAssetID, 10)} StockID={parseInt("0")} ContractID={parseInt("0")} isLock={isLock} />
                                                </div>
                                            )}

                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-userDefineFields' ? 'show active' : ''}`} id="tab-userDefineFields" role="tabpanel">
                                                    <AssetUserDefineFields AssetID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Assetcosts' ? 'show active' : ''}`} id="tab-Assetcosts" role="tabpanel">
                                                    <AssetDocumentPage AssetID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Assetjobs' ? 'show active' : ''}`} id="tab-Assetjobs" role="tabpanel">
                                                    <AssetHistoryPage AssetID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default CustomerDetail;
